export default "__VITE_ASSET__bd0e0861__"